import { useEffect, useState } from 'react';
import ameService from '../service/ame.service';

export default function useAME(enabled) {
  const [codes, setCodes] = useState([]);
  useEffect(() => {
    if (!enabled) return;
    let mounted = true;
    ameService.getOptions().then((rows) => {
      if (mounted) setCodes(rows);
    });
    return () => { mounted = false; };
  }, [enabled]);
  return codes;
}
